import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { TextInput } from '@lib/common';
import { Title } from '@module/form';
import { Form, Select } from 'antd';
import { ImportFileArea } from '../import-file-area';
import { useRef, useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Option = Select.Option;
export var ImportFileInformation = function ImportFileInformation(props) {
  var subjects = props.subjects,
      grades = props.grades,
      isGradeDropdownOpen = props.isGradeDropdownOpen,
      isSubjectDropdownOpen = props.isSubjectDropdownOpen,
      onToggleGradeDropdown = props.onToggleGradeDropdown,
      onCloseGradeDropdown = props.onCloseGradeDropdown,
      onToggleSubjectDropdown = props.onToggleSubjectDropdown,
      onCloseSubjectDropdown = props.onCloseSubjectDropdown,
      label = props.label,
      onImportFileChange = props.onImportFileChange;
  var inputRef = useRef(null);
  var importAreaLabel = {
    dragToUpload: label.dragToUpload,
    or: label.or,
    findFileFromDevice: label.findFileFromDevice
  };
  var filePreviewLabel = {
    deleteMessage: label.deleteFileMessage,
    yes: label.yes,
    no: label.no
  };
  useEffect(function () {
    var _inputRef$current;

    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus({
      cursor: 'end'
    });
  }, []);

  var onBeforeImportFile = function onBeforeImportFile(file) {
    onImportFileChange(file);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Form.Item, {
      label: label.title,
      rules: [{
        required: true,
        message: label.titleEmptyError
      }, {
        validator: function () {
          var _validator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_rule, value) {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;

                    if (!Title.isValid(value)) {
                      _context.next = 5;
                      break;
                    }

                    return _context.abrupt("return", Promise.resolve());

                  case 5:
                    return _context.abrupt("return", Promise.reject(label.invalidTitleLengthError));

                  case 6:
                    _context.next = 11;
                    break;

                  case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](0);
                    throw new Error('Title validate error');

                  case 11:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 8]]);
          }));

          function validator(_x, _x2) {
            return _validator.apply(this, arguments);
          }

          return validator;
        }()
      }],
      name: "title",
      required: true,
      children: /*#__PURE__*/_jsx(TextInput, {
        size: "middle",
        allowClear: true,
        placeholder: label.titlePlaceholder,
        autoFocus: true,
        ref: inputRef
      })
    }), /*#__PURE__*/_jsx(Form.Item, {
      label: label.description,
      name: "description",
      children: /*#__PURE__*/_jsx(TextInput, {
        size: "middle",
        placeholder: label.descriptionPlaceholder
      })
    }), /*#__PURE__*/_jsx(Form.Item, {
      label: label.importFile,
      name: "file",
      required: true,
      children: /*#__PURE__*/_jsx(ImportFileArea, {
        importAreaLabel: importAreaLabel,
        onImportFileChange: onBeforeImportFile,
        filePreviewLabel: filePreviewLabel
      })
    })]
  });
};